import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=8e080b40&scoped=true&"
import script from "./tinymce.vue?vue&type=script&lang=js&"
export * from "./tinymce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e080b40",
  null
  
)

export default component.exports